import React from "react";
import {BrowserRouter} from "react-router-dom";

import { PersistGate } from 'redux-persist/integration/react'

import {ThemeProvider} from '@material-ui/core/styles';
import {createTheme} from "@material-ui/core";

import {Provider} from "react-redux";
import {persistor, store} from "../../redux/store";
import {AuthRouter} from "../../containers/AuthRouter/AuthRouter";


const theme = createTheme(
    {
        palette: {
            primary: {
                light: '#A09DB9',
                main: '#2e5485',
                dark: '#31303b',
                contrastText: '#fff',
            }
        }
    }
)

function App() {
    return <ThemeProvider theme={theme}>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <BrowserRouter>
                    <AuthRouter/>
                </BrowserRouter>
            </PersistGate>
        </Provider>
    </ThemeProvider>
}

export default App
